import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../../theme/ISpcTheme';
import { ButtonProps } from '@material-ui/core/Button';
import { IButtonWithArrowProps } from './ButtonWithArrow';

const ARROW_GIRTH = 3;
export type ButtonWithArrowClasses = 'root' | 'label' | 'arrow';

const buttonWithArrowStyles = makeStyles<ISpcTheme, ButtonProps & IButtonWithArrowProps, ButtonWithArrowClasses>(
  theme => ({
    root: {
      paddingLeft: 20,
      pointerEvents: 'auto',
    },
    label: {
      fontSize: props => (props.labelSize === 'large' ? theme.typography.fontMD : theme.typography.fontSM),
    },
    arrow: {
      '&::after': {
        content: "' '",
        position: 'absolute',
        display: 'block',
        borderStyle: 'solid',
        borderWidth: '3px 0 0 3px',
        borderColor: props =>
          `${!props.disabled ? (theme.palette as any)[props.color || 'primary'].main : theme.palette.text.disabled}`,
        width: props => props.arrowSize,
        height: props => props.arrowSize,
        top: '50%',
        left: '50%',
        transform: props => `translate(-50%, -50%) translate(-${props.arrowSize / 5}px, 0) rotate(135deg)`,
        transition: 'margin .2s',
        borderRadius: `${ARROW_GIRTH / 1.5}px`,
      },
    },
  }),
  { name: 'SPC_ButtonWithArrow' },
);

export default buttonWithArrowStyles;
